import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

export function loaderFactory(): TranslateLoader {
  return new LocalTranslationLoader(
    'attributes',
    'blueprints',
    'catalog',
    'configuration',
    'core',
    'errors',
    'font',
    'home',
    'icon',
    'login',
    'materials',
    'retailers',
    'rule-templates',
    'textures',
    'translations',
    'user',
  );
}

/**
 * Loads translations by merging them all during compile/build time. All translations end up in the js bundle.
 */
class LocalTranslationLoader extends TranslateLoader {
  private _paths: string[];

  constructor(...paths: string[]) {
    super();
    this._paths = paths;
  }

  getTranslation(lang: string): Observable<any> {
    // some magic stuff happens here. the require(..) call results in some webpack plugin merging all jsons from assets/i18n in the bundle.
    // the merging happens at build time!

    // note that using require() on images/css/fonts will result in a hashed filename. this can be used to prevent browser caching issues.
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return of(this._paths.reduce((acc, path) => Object.assign(acc, require(`../../assets/i18n/${path}/${lang}.json`)), {}));
  }
}
